import React from 'react';
import { motion } from 'framer-motion';
import { SectionLabel, SectionHeading } from './ui/UI';
const loop = ['Path found', 'Fix recommended', 'Ticket created', 'Remediation completed', 'Validation re-run', 'Risk verified closed', 'Evidence stored'];
const outcomes = [{
  label: 'Fixed',
  color: '#22c55e',
  desc: 'Risk fully closed.'
}, {
  label: 'Partially fixed',
  color: '#84cc16',
  desc: 'Some path elements remain.'
}, {
  label: 'Still exposed',
  color: '#ef4444',
  desc: 'Remediation did not close the risk.'
}, {
  label: 'Mitigated by control',
  color: '#1a8fd4',
  desc: 'Compensating control reduces risk.'
}, {
  label: 'Inconclusive',
  color: '#a78bfa',
  desc: 'More information needed.'
}, {
  label: 'Reopened due to drift',
  color: '#f97316',
  desc: 'Was fixed, now exposed again.'
}, {
  label: 'Closed without evidence',
  color: '#737373',
  desc: 'Activity completed, proof missing.'
}];
export function Verification() {
  return <section className="relative w-full py-32 border-t border-white/5" data-id="element-838">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-839">
        <SectionLabel number="11" label="Fix Verification" className="mb-8" data-id="element-840" />

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16" data-id="element-841">
          <div className="lg:col-span-8" data-id="element-842">
            <SectionHeading size="xl" data-id="element-843">
              Closed tickets are
              <br data-id="element-844" />
              <span className="text-white/40" data-id="element-845">not closed risk.</span>
            </SectionHeading>
          </div>
          <div className="lg:col-span-4 lg:pt-4" data-id="element-846">
            <p className="text-lg text-white/60 leading-relaxed" data-id="element-847">
              Most security tools stop when a finding is created. Periscan
              closes the loop and turns remediation from an assumption into
              proof.
            </p>
          </div>
        </div>

        {/* Loop visualization */}
        <div className="mb-16" data-id="element-848">
          <p className="font-mono text-xs uppercase tracking-widest text-white/40 mb-8" data-id="element-849">
            The Loop
          </p>
          <div className="relative grid grid-cols-1 md:grid-cols-7 gap-2" data-id="element-850">
            {loop.map((step, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: i * 0.08
          }} className="relative p-4 rounded-xl bg-[#0a0d12] border border-white/[0.06] hover:border-[#1a8fd4]/40 transition-colors" data-id="element-851">
                <span className="font-mono text-[10px] text-[#1a8fd4]/60 mb-2 block" data-id="element-852">
                  {String(i + 1).padStart(2, '0')}
                </span>
                <p className="text-sm text-white font-medium" data-id="element-853">{step}</p>
              </motion.div>)}
          </div>
        </div>

        {/* Outcome table */}
        <div data-id="element-854">
          <p className="font-mono text-xs uppercase tracking-widest text-white/40 mb-8" data-id="element-855">
            Remediation Outcomes
          </p>
          <div className="space-y-px bg-white/5 rounded-2xl overflow-hidden border border-white/5" data-id="element-856">
            {outcomes.map((o, i) => <motion.div key={i} initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: i * 0.04
          }} className="bg-[#070a0e] grid grid-cols-12 gap-4 px-6 py-5 hover:bg-[#0a0d12] transition-colors items-center" data-id="element-857">
                <div className="col-span-12 md:col-span-4 flex items-center gap-3" data-id="element-858">
                  <div className="w-2 h-2 rounded-full" style={{
                backgroundColor: o.color,
                boxShadow: `0 0 8px ${o.color}`
              }} data-id="element-859" />
                  <span className="text-base font-medium text-white" data-id="element-860">
                    {o.label}
                  </span>
                </div>
                <div className="col-span-12 md:col-span-8" data-id="element-861">
                  <span className="text-base text-white/60" data-id="element-862">{o.desc}</span>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}